var LengthUnit_1;
import { __decorate } from "tslib";
import { Unit } from './Unit';
import { SerializableObject } from '../../data/decorators';
import { UnitPrefix } from './UnitPrefix';
/**
 * @category Unit
 */
let LengthUnit = LengthUnit_1 = class LengthUnit extends Unit {};
LengthUnit.METER = new LengthUnit_1('meter', {
  baseName: 'length',
  aliases: ['m', 'meters'],
  prefixes: 'decimal'
});
LengthUnit.CENTIMETER = LengthUnit_1.METER.specifier(UnitPrefix.CENTI);
LengthUnit.MILLIMETER = LengthUnit_1.METER.specifier(UnitPrefix.MILLI);
LengthUnit.KILOMETER = LengthUnit_1.METER.specifier(UnitPrefix.KILO);
LengthUnit.MILE = new LengthUnit_1('mile', {
  baseName: 'length',
  aliases: ['mil', 'miles'],
  definitions: [{
    unit: 'meter',
    magnitude: 1609.344
  }]
});
LengthUnit = LengthUnit_1 = __decorate([SerializableObject()], LengthUnit);
export { LengthUnit };